"use client";
import Link from "next/link";
import React, { useState, useContext } from "react";
import { useDispatch } from "react-redux";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import HeaderCartIcon from "@/svg/HeaderCartIcon";

import HeaderLogo from "../../../public/assets/img/logo/logo.png";

import Image from "next/image";
import useScrollDirection from "@/hooks/sticky-header";
import { AppContextType } from "@/interFace/general";
import { AppContext } from "@/contextApi/AppProvider";

import MemoAuthMenu from "./MemoAuthMenu";
import MobileAuthMenu from "./component/MobileAuthMenu";
import { getLink, Routes } from "@/constants";
import { Culture } from "@/components/languages/CulturesV2";

const MemoAuthHeader = () => {
  const scrollDirection = useScrollDirection(null);
  const { toggleSideMenu, sideMenuOpen, locale, currentUser, userInfo } = useContext(
    AppContext
  ) as AppContextType;

  const [cartOpen, setCartOpen] = useState(false);
  // redux import
  const dispatch = useDispatch();
  const cartProducts = useSelector(
    (state: RootState) => state.cart.cartProducts
  );
  const uniqueProductIds = new Set();
  cartProducts?.forEach((product) => uniqueProductIds.add(product.id));
  const quantityProduct = uniqueProductIds?.size;

  const totalItems = cartProducts?.reduce(
    (total, product) => total + product.quantity,
    0
  );
  const resolvedWorkspace = userInfo.activeWorkspace ?? userInfo.defaultWorkspace;
  const logoTargetUrl = !currentUser?.uid
    ? getLink(locale, Routes.HOMEPAGE)
    : resolvedWorkspace === "claimant"
      ? getLink(locale, Routes.CLAIMANT_ROOT)
    : resolvedWorkspace === "tutor"
      ? getLink(locale, Routes.TUTORS_ROOT)
      : resolvedWorkspace === "parent"
        ? getLink(locale, Routes.PARENTS_ROOT)
        : userInfo.activeRole === "claimant" || userInfo.roles.includes("claimant")
          ? getLink(locale, Routes.CLAIMANT_ROOT)
        : userInfo.activeRole === "tutor" || userInfo.roles.includes("tutor")
          ? getLink(locale, Routes.TUTORS_ROOT)
          : userInfo.activeRole === "parent" || userInfo.roles.includes("parent")
            ? getLink(locale, Routes.PARENTS_ROOT)
            : getLink(locale, Routes.DASHBOARD_COURSES);

  // console.log("quantityProduct", cartProducts);
  return (
    <>
      <header>
        <div
          id="header-sticky"
          className={`header__area header__transparent header__padding-2 ${
            scrollDirection === "down" ? "sticky" : ""
          }`}
        >
          <div className="container">
            <div className="row align-items-center">
              {/* logo area */}
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-2 col-sm-4 col-6">
                <div className="header__left d-flex">
                  <div>
                    <div className="logo">
                      <Link href={logoTargetUrl}>
                        <Image
                          src={HeaderLogo}
                          style={{ width: "72px", height: "auto", minWidth: "72px" }}
                          className="logo-header-img"
                          alt="logo"
                        />
                      </Link>
                    </div>
                    <div className="d-xl-none" style={{ marginTop: "10px" }}>
                      <Culture />
                    </div>
                  </div>
                </div>
              </div>
              {/* menu area */}
              <div className="col-xxl-9 col-xl-9 col-lg-8 col-md-10 col-sm-8 col-6">
                <div className="header__right d-flex justify-content-end align-items-center">
                  {/* nav menu large screen */}
                  <div className="main-menu main-menu-2 d-none d-xl-block">
                    <nav id="mobile-menu ">
                      <ul>
                        <MemoAuthMenu />
                        <li> 
                          <div className="culture">
                            <Culture />
                          </div>
                        </li>
                        {/* cart icon large screen */}
                        <li>
                          <div className="header__search p-relative ml-50 d-none d-md-block">
                            <div className="header__cart">
                              <Link href={`/en/cart`}
                                    className="cart-toggle-btn">
                                  <HeaderCartIcon />
                                  <span className="cart-item">
                                    {totalItems}
                                  </span>
                              </Link>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  {/* mobile area screen */}
                  {/* cart icon small screen */}
                  <div className="header__cart header__cart--responsive header__cart--responsive__white">
                    <span
                      className="cart-toggle-btn"
                      onClick={() => {
                        setCartOpen(!cartOpen);
                      }}
                    >
                      <Link href={Routes.CART}>
                        <HeaderCartIcon />
                      </Link>
                      <span className="cart-item">{totalItems}</span>
                    </span>
                  </div>
                  {/* hamburguer menu */}
                  <div className="sidebar__menu d-xl-none">
                    <div
                      onClick={toggleSideMenu}
                      className="sidebar-toggle-btn ml-30"
                      id="sidebar-toggle"
                    >
                      <span className="line"></span>
                      <span className="line"></span>
                      <span className="line"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileAuthMenu />
      <div
        onClick={toggleSideMenu}
        className={sideMenuOpen ? "body-overlay opened" : "body-overlay"}
      ></div>
    </>
  );
};

export default MemoAuthHeader;
